import phoneModelValidator from 'forms/shared/validators/models/phone/phone';
import emailModelValidator from 'forms/shared/validators/models/pvqEmail/email';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { IdentificationContactModel } from './types';

export const contactPhoneNumber = {
  Telephone: {
    model: {
      validator: phoneModelValidator,
      requireNumberType: true,
    },
  },
};

export const pvqEmail = {
  Email: {
    model: {
      validator: emailModelValidator,
      requireEmailType: false
    }
  },
};

const identificationContactValidator: ValidateJSModel<IdentificationContactModel> = {
  HomeEmail: (value, attributes, attributeName, options) => {
    // This should be sufficient, unless we want to support "optional"
    // email. If so, then this may not work.
    if (options?.requireIdentificationContactInfo === false) { return {}; }
    if (isPVQForm(options?.formType)) { return {}; }

    if (attributes?.WorkEmail?.value) {
      if (attributes?.HomeEmail?.value) {
        return {
          hasValue: { validator: { email: true } },
        };
      }
      return {};
    }

    return {
      hasValue: { validator: { email: true } },
    };
  },
  WorkEmail: (value, attributes, attributeName, options) => {
    if (options?.requireIdentificationContactInfo === false) { return {}; }
    if (isPVQForm(options?.formType)) { return {}; }

    if (attributes?.HomeEmail?.value) {
      if (attributes?.WorkEmail?.value) {
        return {
          hasValue: { validator: { email: true } },
        };
      }
      return {};
    }

    return {
      hasValue: { validator: { email: true } },
    };
  },
  PhoneNumbers: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) ? {
      presence: true,
      accordion: {
        ignoreBranch: true,
        validator: contactPhoneNumber,
      },
    } : {
      presence: true,
      accordion: {
        ignoreBranch: true,
        validator: contactPhoneNumber,
        itemsValidator: (items: IdentificationContactModel['PhoneNumbers']['items']) => {
          const numberTypes: any[] = [];
          items.forEach((i) => {
            if (i.Item && i.Item.Telephone) {
              numberTypes.push(i.Item.Telephone.numberType);
            }
          });
          const unique = [...new Set(numberTypes)];
          if (numberTypes.length === unique.length) { return null; }
          // TODO: go back and clean up; DUPLICATE_PHONE_NUMBER_TYPES error message doesn't actually pertain to number types but numbers themselves,
          //       so can't use default const
          return 'DUPLICATE_PHONE_NUMBER_TYPES';
        },
      },
    }),
  Emails: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) ? {
      presence: true,
      accordion: {
        ignoreBranch: true,
        validator: pvqEmail,
      },
    } : {}),
};

export default identificationContactValidator;
